import script from "./DashboardBarChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardBarChart.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardBarChart.vue?vue&type=style&index=0&id=ed84ad08&lang=scss"

const __exports__ = script;

export default __exports__